import {
  Stack,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import style from './styles/Toggle.Button.module.scss';
const ToggleButtonCreator = ({
  iconArray,
  //eg...
  // [
  //   {
  //     value: "svg",
  //     icon: <Info />,
  //   },
  //   {
  //     value: "notSvg",
  //     icon: <Info />,
  //   },
  // ]
  defaultValue = '',
  ariaLabel = '',
  stateLift,
  onChange,
  sx = {},
  disabled = false,
}) => {
  const [value, setValue] = useState(() => defaultValue);
  const HandleChange = (event, val) => {
    if (val) {
      setValue(val);
      onChange && onChange(val);
    }
  };
  const memoizedIcons = useMemo(
    () => iconArray,
    [iconArray]
  );

  useEffect(() => {
    if (stateLift && value) {
      stateLift(value);
    }
  }, [stateLift, value]);
  return (
    <React.Fragment>
      <ToggleButtonGroup
        defaultValue={defaultValue}
        value={value}
        onChange={HandleChange}
        aria-label={ariaLabel}
        exclusive={true}
        orientation="horizontal"
        sx={{ mt: '1em', ...sx }}
        classes={{
          root: style.root,
          groupedHorizontal: style.horizontal,
        }}
      >
        {memoizedIcons.map((data) => (
          <ToggleButton
            key={data.value}
            value={data.value}
            aria-label={data.value}
            fullWidth
            color="colorPrimer"
            size="small"
            sx={{
              color: 'unset !important',
            }}
            disabled={disabled}
          >
            {data.icon || data.text}
            {data.iconText ? (
              <Stack
                direction="row-reverse"
                alignItems="center"
                gap=".3em"
              >
                {data.iconText.icon}
                {data.iconText.text}
              </Stack>
            ) : (
              <></>
            )}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </React.Fragment>
  );
};

export default ToggleButtonCreator;
